import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {actions} from '../actions';
import {TimeslotsState} from '../stateTypes';

export const extendWithConnectionWorkspaceReservationsReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.fetchWorkspaceReservationsForConnections.pending, (state, action) => {
      const dateKey = action.meta.arg.date;
      state.connectionWorkspaceReservationsByDate[dateKey] = {
        status: 'pending',
        data: state.connectionWorkspaceReservationsByDate[dateKey]?.data ?? null,
        requestId: action.meta.requestId,
      };
    })
    .addCase(actions.fetchWorkspaceReservationsForConnections.fulfilled, (state, action) => {
      const dateKey = action.meta.arg.date;
      state.connectionWorkspaceReservationsByDate[dateKey] = {
        status: 'fulfilled',
        data: action.payload,
      };
    })
    .addCase(actions.fetchWorkspaceReservationsForConnections.rejected, (state, action) => {
      const dateKey = action.meta.arg.date;
      state.connectionWorkspaceReservationsByDate[dateKey] = {
        status: 'rejected',
        data: null,
        errorMessage:
          action.error.message ??
          `Something went wrong loading the workspace reservations of ${dateKey} for connections`,
      };
    });
};
